var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 9.33337H3.6C2.71634 9.33337 2 10.0796 2 11V21C2 21.9205 2.71634 22.6667 3.6 22.6667H16.4C17.2837 22.6667 18 21.9205 18 21V11C18 10.0796 17.2837 9.33337 16.4 9.33337Z",
    stroke: "currentColor",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 9.33337V6.93337C15.3327 5.44816 14.7708 4.02378 13.7706 2.97358C12.7704 1.92337 11.4138 1.33337 9.99935 1.33337C8.58486 1.33337 7.22831 1.92337 6.22811 2.97358C5.22792 4.02378 4.66602 5.44816 4.66602 6.93337V9.33337",
    stroke: "currentColor",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 17.3333C10.7357 17.3333 11.3327 16.7363 11.3327 16C11.3327 15.2636 10.7357 14.6666 9.99935 14.6666C9.26297 14.6666 8.66602 15.2636 8.66602 16C8.66602 16.7363 9.26297 17.3333 9.99935 17.3333Z",
    fill: "currentColor"
  })));
};
export default SvgLock;